import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Circle from 'ol/style/Circle';
import ZoomToExtent from 'ol/control/ZoomToExtent';
import FullScreen from 'ol/control/FullScreen';

import ol_ext_inherits from 'ol-ext/util/ext'
import Bar from 'ol-ext/control/Bar'

import MeasureLine from './MeasureLine'
import MeasureArea from './MeasureArea'
import LegendControl from './LegendControl'
import ZoomDragboxControl from './ZoomDragboxControl'


var CommonControls = function (options) {


    Bar.call(this, options);

    this.source = new VectorSource();

    this.vector = new VectorLayer({
        displayInLayerSwitcher: false,

        baseLayer: false,
        source: this.source,
        style: new Style({
            fill: new Fill({
                color: 'rgba(255, 255, 255, 0.2)'
            }),
            stroke: new Stroke({
                color: '#ffcc33',
                width: 2
            }),
            image: new Circle({
                radius: 7,
                fill: new Fill({
                    color: '#ffcc33'
                })
            })
        })
    });

    this.measureLineToggle = new MeasureLine({
        source: this.source
    })
    this.measureAreaToggle = new MeasureArea({
        source: this.source
    })

    this.legendControl=new LegendControl();

    this.zoomDragboxControl = new ZoomDragboxControl();

    this.nested = new Bar({
        toggleOne: true,
        group: true
    });
    if(options.zoomtoextent) {
        var span = document.createElement('span');
        span.className="icon";
        options.zoomtoextent.label = options.zoomtoextent.label || span;
    }
    
    this.addControl(new ZoomToExtent(options.zoomtoextent));
    this.addControl(this.nested);
    this.nested.addControl(this.zoomDragboxControl);
    this.nested.addControl(this.measureLineToggle);
    this.nested.addControl(this.measureAreaToggle);
    this.nested.addControl(this.legendControl);
    


}

ol_ext_inherits(CommonControls, Bar);

CommonControls.prototype.setMap = function (map) {
    Bar.prototype.setMap.call(this, map);
    map.addLayer(this.vector);
}
export default CommonControls